import { ErrorHandler, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class PopErrorHandler implements ErrorHandler {
  public static hasErrors = false;

  public constructor(
    private logger: NGXLogger,
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) { }

  public handleError(error: Error): void {
    this.logger.error(error);
    this.logger.error(`[PopErrorHandler]: ${error.message?.substring(0, 300)}`);
    try {
      const json = JSON.stringify(error);
      this.logger.error(json);
    } catch {
      // nevermind (circular json)
    }

    if (!PopErrorHandler.hasErrors) {
      PopErrorHandler.hasErrors = true;
      const errorMessage = this.translateService.instant('ERROR.GENERIC') as string;
      const action = this.translateService.instant('BUTTON.CLOSE') as string;

      const snackBarRef = this.snackBar.open(errorMessage, action, {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar'],
        duration: 10 * 1000
      });

      snackBarRef.afterDismissed().subscribe(() => {
        PopErrorHandler.hasErrors = false;
      });
    }
  }
}
